import React from "react";
import { ObjectLayer } from "../../Core/Api/Types/object-layer";
import { FilterContext } from "../../Layouts/Dashboard/dashboard";
import { MetadataFieldValueObjectTypes } from "../../Core/Api/Types/metadata-field-value-object-types";
import { DbMetadataFieldInfos } from "../../Core/Api/Types/db-metadata-field-infos";
import { CHILDREN_PAGE_SIZE, useSearchPagination } from "../../Components/Drive/helpers/use-drive-pagination";

export const useFiltersPanel = () => {
  const filterContext = React.useContext(FilterContext);
  const { loadSearchContent } = useSearchPagination();

  const {
    openFiltersPanel: filtersPanelOpen,
    openFiltersPanelLayer: filterPanelLayer,
    openFiltersPanelType: filterPanelType,
    openFiltersPanelMetadataFields: filterPanelMetadataFields,
    setOpenFiltersPanel: setFiltersPanelOpen,
    setOpenFiltersPanelLayer: setFiltersPanelOpenLayer,
    setOpenFiltersPanelType: setFiltersPanelOpenType,
    setOpenFiltersPanelMetadataFields: setFiltersPanelOpenMetadataFields,
  } = filterContext;

  const openFiltersPanel = (
    type: MetadataFieldValueObjectTypes,
    layer: ObjectLayer | null,
    metadataFields?: DbMetadataFieldInfos[]
  ) => {
    console.log("Open filter panel on layer " + layer + " and type = " + type);

    setFiltersPanelOpenLayer(layer);
    setFiltersPanelOpenType(type);

    if (metadataFields) {
      setFiltersPanelOpenMetadataFields(metadataFields);
      console.log("Panel metadata fields overrided");
    }

    setFiltersPanelOpen(true);
  };

  const closeFiltersPanel = () => {
    setFiltersPanelOpen(false);
    loadSearchContent({ page: 0, pageSize: CHILDREN_PAGE_SIZE }, true);
  };

  return {
    openFiltersPanel,
    closeFiltersPanel,
    filtersPanelOpen,
    filterPanelLayer,
    filterPanelType,
    filterPanelMetadataFields,
  };
};
